import { useLanguage } from '../contexts/LanguageContext';

const LANG_SLUGS = { EN: 'en', PT: 'pt-br', ES: 'es' } as const;

/** Returns a path prefixed with the current language slug: /services → /en/services */
export function useLocalePath(path: string): string {
    const { language } = useLanguage();
    const slug = LANG_SLUGS[language];
    return `/${slug}${path.startsWith('/') ? path : `/${path}`}`;
}

/** Returns the slug for a given Language */
export function langToSlug(lang: 'EN' | 'PT' | 'ES'): string {
    return LANG_SLUGS[lang];
}

/** Returns the Language for a given slug */
export function slugToLang(slug: string): 'EN' | 'PT' | 'ES' {
    switch (slug) {
        case 'pt-br': return 'PT';
        case 'es': return 'ES';
        default: return 'EN';
    }
}

export const SUPPORTED_SLUGS = ['en', 'pt-br', 'es'] as const;
